import type { DrawerProps } from '@mui/material/Drawer';
import Drawer from '@mui/material/Drawer';
import type { CSSObject, Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';

const openedMixin = (theme: Theme): CSSObject => ({
  overflowX: 'hidden',
  padding: 0,
  borderRadius: 0,
  width: theme.layout.sidebar.maxWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
});

const closedMixin = (theme: Theme): CSSObject => ({
  overflowX: 'hidden',
  padding: 0,
  borderRadius: 0,
  width: theme.layout.sidebar.minWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
});

const SidebarDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})<DrawerProps>(({ theme, open }) => ({
  width: theme.layout.sidebar.maxWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
  '& .MuiDrawer-paper': {
    background: (
      theme.palette as unknown as Record<string, Record<string, string>>
    ).blue[900],
  },
}));

SidebarDrawer.displayName = 'SidebarDrawer';
export default SidebarDrawer;
